"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Rate = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Rate"));

// Generated by script, don't edit it please.
var Rate = (0, _createSvgIcon["default"])({
  as: _Rate["default"],
  ariaLabel: 'rate',
  category: 'application',
  displayName: 'Rate'
});
var _default = Rate;
exports["default"] = _default;
module.exports = exports.default;